import { useState } from 'react';
import './Form.css';

function Form() {
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('');

  const handleTextareaChange = (e) => {
    setMessage(e.target.value);
    e.target.style.height = '0px';
    e.target.style.height = e.target.scrollHeight + 'px';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;

    const data = {
      name: form.name.value,
      email: form.email.value,
      message: form.message.value,
      _hp: form._hp.value,
    };

    try {
      const response = await fetch('/.netlify/functions/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        setStatus('success');
        setMessage('');
        form.reset();
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div className="form-container">
      <h2>GET IN TOUCH</h2>
      {status === 'success' ? (
        <p className="success-message">Thank you! Your message has been sent.</p>
      ) : (
        <form onSubmit={handleSubmit}>
          {/* Honeypot — hidden from humans, bots fill it in */}
          <input type="text" name="_hp" style={{ display: 'none' }} tabIndex="-1" autoComplete="off" />
          <div className='form-column'>
            <input className="form-input-email" type="text" name="name" placeholder="Your name" />
            <input className="form-input-email" type="email" name="email" placeholder="Your email" />
            <textarea
              className="form-input-textarea"
              name="message"
              placeholder="Your message here"
              value={message}
              onChange={handleTextareaChange}
              rows="3"
            ></textarea>
            <button type="submit">Send</button>
            {status === 'error' && <p className="error-message">Oops! There was an error sending your message.</p>}
          </div>
        </form>
      )}
    </div>
  );
}

export default Form;
